const ErrorPage = () => {
  return <div className=" flex h-screen w-screen items-center  justify-center">Something went wrong!</div>;
};

export default ErrorPage;
